import React from "react";
import PropTypes from "prop-types";
import "./Spinner.style.scss";

const Spinner = ({ size = "medium" }) => {
  let sz;

  if (size === "small") {
    sz = "fa-1x";
  } else if (size === "medium") {
    sz = "fa-2x";
  } else if (size === "large") {
    sz = "fa-3x";
  }

  return (
    <div className="spinner">
      <i className={`fa fa-spinner fa-pulse  fa-fw ${sz}`} />
    </div>
  );
};

Spinner.propTypes = {
  size: PropTypes.string,
};
export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/spinner/Spinner.jsx